module.exports = __webpack_public_path__ + "9c5afc2a0b5b886a24bae58ea543352e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/Slider/images/image1.png
// module id = xD39
// module chunks = 0